import {useLocation, useNavigate} from "react-router-dom";
import React, {useEffect, useState} from "react";
import {hideLoading, showLoading} from "@/components/loading";
import {getReceive} from "@/api/projectManager_self";
import {Button, Toast} from "antd-mobile";
import {getUrlAllParams} from "@/utils/publicFun";
import classNames from "classnames";
import NFTHeader from "@/components/NFTHeader";
import {Swiper, SwiperSlide} from "swiper/react";
import {EffectCards} from "swiper";
import './index.scss'
import ToPointComponent from "@/view/nftPad/paySuccess/ToPointComponent";

export default () => {
  const navigate = useNavigate()
  const { state = {
    collectionList: [{ image: '', nftNo: "", collectionName: "", collectionType: 19, canConvert: 0, convertType: null, convertCount: null }],
    title: "",
    from: undefined/* 跳转来源 */
  }} = useLocation()
  // 共创漫画开盲盒参数
  const { search } = useLocation()
  //req:流水号
  const { code, req } = getUrlAllParams(search.slice(1));

  const [hash, setHash] = useState()
  const [activeIndex, setActiveIndex] = useState(0)
  const [blinBox, setBlinBox] = useState(
    /*[{
      url: require('@/assets/img/ape-world/egg_bg_xiangqingye.png'),
      title: '开盲盒',
      nftNo: 'xxxxx'
    }]*/
  )
  const [blinBoxCount, setBlinBoxCount] = useState(0)
  const [pointListTabShow, setPointListTabShow] = useState(false)
  const [convertList, setConvertList] = useState([])

  const bridge = window.JsBridge

  useEffect(() => {
    setHash(state?.collectionList[0]?.hash)
    if(state?.collectionList?.length > 0) {
      setConvertList(state.collectionList.filter(item => item.canConvert === 1))
    }
    if (state?.title) {
      bridge.setTitle(state?.title)
    } else {
      bridge.setTitle("支付成功")
    }
    if (req && code) {
      bridge.setTitle("开盒中")
      getBlinBoxData()
    }
  }, [])

  const onTabChange = (pointListTabShow) => {
    setPointListTabShow(pointListTabShow)
    bridge.setTitle(pointListTabShow ? "藏品权益批量转化" : "支付成功")
  }
  const getBlinBoxData = async () => {
    try {
      showLoading()
      const res = await getReceive({ req, code })
      hideLoading();
      if (res.code !== '000000') throw res.msg;
      if (res.data && res.data.collectionsInfo) {
        bridge.setTitle("开盒成功")
        const totalCount = res.data.totalCount || 0
        setBlinBoxCount(totalCount)
        let list = res.data.collectionsInfo || []
        list = list.map(item => {
          if (item.url && item.url.includes('?')) {
            item.url = item.url.split('?')[0]
          }
          return item
        })
        setBlinBox(list)

      } else {
        throw '开盲盒失败';
      }
    } catch (error) {
      bridge.setTitle("开盒失败")
      Toast.show(error);
    }

  }

  const gotoDetail = () => {
    const url = `/myCollection`
    if (window.JsBridge.hasWebViewBridge()) {
      window.JsBridge.replace("CustomWeb", { uri: `${window.location.origin}${url}` });
    } else {
      navigate(url, { replace: true });
    }
  }

  const slideChange = (e) => {
    setHash(state?.collectionList[e.activeIndex]?.hash)
    setActiveIndex(e.activeIndex)
  }

  const returnDiv = () => {
    const sources= JSON.parse(window.localStorage.getItem('source3d') || '{}')
    if (sources?.length > 0) {
      return (
        <>
          {
            sources.map((item, i) => {
              const directions = ['front', 'rear', 'left', 'right', 'up', 'down'];
              return (
                <div className={classNames('face', directions[i])} key={i}>
                  <img src={item} alt="" />
                </div>
              )
            })
          }
        </>
      )
    }
    return null;
  }

  //设置背景
  const setOutbgimg = () => {
    let className = ''
    if ([210, 211, 212, 213, 217, 218, 219, 220, 221, 222].includes(state?.collectionList[0]?.collectionType)) {
      className = 'white_bg'
    }
    return className
  }
  return (
    <div className={classNames('pay_success', setOutbgimg())}>
      {+state?.showNav === 1 && <NFTHeader midText={state.title} bgColor={'#FFFFFF'} />}
      <div className="pay_success_bg">
        {pointListTabShow ?
          <ToPointComponent dataSource={convertList}/> :
          <div>
            <div className="banner">
              <div className="stage">{returnDiv()}</div>
              <div className={classNames("collectionList", 'fade-in')}>
                {
                  state?.collectionList &&
                  <Swiper effect={"cards"} grabCursor={true} modules={[EffectCards]} className="mySwiper" onSlideChange={slideChange}>
                    {state?.collectionList &&
                      state?.collectionList.map((item, index) => (
                        <SwiperSlide key={index}>
                          {
                            item.collectionType == 19 ?
                              <div className="swiper_item">
                                <img src={item.image} alt="" className="img_19" />
                                <span className={index === activeIndex ? "show_text_19" : "hidden_text"}>
                              <span className="blod_text">{item.collectionName}</span>
                              <br />
                              <span>藏品编号：{item.nftNo}</span>
                            </span>
                              </div> :
                              <div className="swiper_item">
                                <img src={item.image} alt="" />
                                <span className={
                                  index === activeIndex ?
                                    classNames("text_style", {
                                      text_style__dark: ['europeanCup', 'apeBindBox', 'healthPreservation', 'wxh'].includes(state.from)
                                    })
                                    : "hidden_text"
                                }>
                              <span className={`blod_text`}>{item.collectionName}</span>
                              <br />
                              <span className={'num_style'}>#{item.nftNo}</span>
                            </span>
                              </div>
                          }
                        </SwiperSlide>
                      ))}
                  </Swiper>
                }
                {/* 漫画开盲盒 */}
                {
                  blinBox && blinBox.length > 0 &&
                  <>
                    <Swiper effect={"cards"} grabCursor={true} modules={[EffectCards]} className="blinBox_Swiper" onSlideChange={slideChange}>
                      {
                        blinBox.map((item, index) => (
                          <SwiperSlide key={index}>
                            <img src={item.url} alt="" />
                            <span className={index === activeIndex ? "show_text" : "hidden_text"}>
                          <span className="blod_text">{item.title}</span>
                          <br />
                          <span>藏品编号：{item.nftNo}</span>
                        </span>
                          </SwiperSlide>
                        ))
                      }
                    </Swiper>
                    <div className="blinbox_count">共{blinBoxCount || 0}个藏品</div>
                  </>
                }
              </div>
            </div>
            <div className="bottom-btns">
              <Button size="large" className="detail_btn" onClick={gotoDetail}>
                查看藏品详情
              </Button>
              {convertList?.length > 0 && (
                <Button size="large" className="transform_btn" onClick={() => onTabChange(true)}>
                  转化为{convertList[0]?.convertType === 1 ? '宝石' : '积分'}
                </Button>
              )}
            </div>
          </div>}
      </div>
    </div>
  )
}
